import { HeaderLogoContainer } from "../SnaptradeModal.styles";
import { emblem } from "assets/icons";
import { iconSnaptrade } from "assets/icons";

const HeaderLogo = () => {
  return (
    <HeaderLogoContainer>
      <div className="img-wrapper">
        <img src={iconSnaptrade} />
      </div>
      <div className="img-wrapper emblem">
        <img src={emblem} />
      </div>
    </HeaderLogoContainer>
  );
};

export default HeaderLogo;
